import React from 'react';
import Scrollbar from 'react-smooth-scrollbar';
export default props => (
  <Scrollbar id={props.id} className={props.className} style={props.style} continuousScrolling={true}>
    {props.children}
  </Scrollbar>
);
